import "./auth-pages.scss";

import { Field, Form, Formik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { object, string } from "yup";

import {
  reset_password,
  wipe_password_reset,
} from "shared/actions/authActions";

import BannerController from "components/BannerController";
import TextInput from "components/customInputs/TextInput";
import dotLogoSrc from "images/PathologyWatch_Dot_Logo_w Pw.png";
import ApplicationState from "store/ApplicationState";
import { AppDispatch } from "store/store";

import ToastList from "../toasts/ToastList";

let schema = object().shape({
  email: string().email().required(),
});

type ResetPasswordPageProps = {};

const ResetPasswordPage = (_props: ResetPasswordPageProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { detail, error } = useSelector(
    ({ passwordReset }: ApplicationState) => passwordReset
  );

  useEffect(() => {
    dispatch(wipe_password_reset());
  }, []);

  return (
    <>
      <ToastList />
      <main className="auth-pages">
        <BannerController />
        <div className="auth-pages__content">
          <Link to="/">
            <figure className="DotLogo">
              <img src={dotLogoSrc} alt="dot. by PathologyWatch" />
            </figure>
          </Link>
          <span className="hr" />
          <h1>Need help with your password?</h1>
          <div className="form-div">
            <h2>Enter your recovery email address</h2>
            <h6>We will send a new code to reset your password.</h6>
            <Formik
              initialValues={{ email: "" }}
              validationSchema={schema}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(reset_password(values));
                setSubmitting(false);
              }}
            >
              {({
                isSubmitting,
                errors,
                touched,
                handleChange,
                handleSubmit,
              }) => (
                <Form onSubmit={handleSubmit} translate="yes">
                  {error && error.message && (
                    <div className="alarm alarm-red">{error.message}</div>
                  )}
                  {detail && <div className="alarm alarm-green">{detail}</div>}
                  <Field name="email">
                    {({ field }: any) => (
                      <TextInput
                        required
                        type="email"
                        id="email"
                        placeholder="Email"
                        {...field}
                        onChange={handleChange}
                        className="text-form-field"
                      />
                    )}
                  </Field>
                  {errors.email && touched.email && (
                    <div className="formik-error">{errors.email}</div>
                  )}
                  <div className="PageLayout">
                    <button
                      type="submit"
                      title="Log In"
                      className="Button--blue"
                      disabled={isSubmitting}
                    >
                      SEND
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <footer>
            <Link to="/">Back to Login</Link>
          </footer>
        </div>
      </main>
    </>
  );
};

export default ResetPasswordPage;
